// extracted by mini-css-extract-plugin
export var element_wrapper = "faq-element-module--element_wrapper--2m-B4";
export var active = "faq-element-module--active--1gkdT";
export var top_bar = "faq-element-module--top_bar--3IH_k";
export var content = "faq-element-module--content--xR6hZ";